import type { DeviceDetailSection } from '../../-shared/-query/type';

const CURRENT_STATUS_KEY = 'CurrentStatus';

export function splitStatusSections(sections: DeviceDetailSection[]) {
  const currentStatus: DeviceDetailSection[] = [];
  const schedules: DeviceDetailSection[] = [];

  for (const section of sections) {
    if (String(section.sectionKey) === CURRENT_STATUS_KEY) {
      currentStatus.push(section);
    } else {
      schedules.push(section);
    }
  }

  return { currentStatus, schedules };
}
